// extracted by mini-css-extract-plugin
export var gif = "_dv-0";